import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';
import './ShowTagsToggle.css';

import { Toggle } from 'components/core/forms';
import GroupTitle from './GroupTitle';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const messages = defineMessages({
  title: {
    id: 'AssetFeed.ViewMenu.ShowTagsToggle.title',
    defaultMessage: 'Show Tags',
    description: 'View menu show tags title',
  },
});

const ShowTagsToggle = ({ showTags, setShowTags }) => {
  const { formatMessage } = useIntl();

  return (
    <Wrapper>
      <GroupTitle>{formatMessage(messages.title)}</GroupTitle>
      <Toggle
        id="show-tags-toggle"
        name="show-tags-toggle"
        checked={showTags}
        onChange={() => {
          setShowTags(!showTags);
        }}
        data-testid="view_menu__show-tags"
      />
    </Wrapper>
  );
};

ShowTagsToggle.propTypes = {
  showTags: PropTypes.bool.isRequired,
  setShowTags: PropTypes.func.isRequired,
};

export default ShowTagsToggle;
